(async () => {
  if (!customElements.get("register-device")) {
    class RegisterDevice extends HTMLElement {
      constructor() {
        super();
        this.initialise();
      }

      async initialise() {
        // set key and url for current environment.
        if (window.location.hostname === "www.kiiroo.com") {
          this.KEY = "fae3c71c-96f4-11e7-92b5-1c1b0d9f5ea2";
          this.BASE_URL = "https://register.kiiroo.com/api";
        } else {
          this.KEY = "woop12345";
          this.BASE_URL = "https://register-stage.kiiroo.com/api";
        }
        this.TOKEN_URL = this.BASE_URL + "/token?api_key=" + this.KEY;
        this.DEVICE_URL = this.BASE_URL + "/devices?apptoken=";
        this.REGISTER_URL = this.BASE_URL + "/device_registration?apptoken=";

        // Get necessary elements
        this.form = this.querySelector("[data-form]");
        this.submitBtn = this.querySelector("[data-submit-btn]");
        this.submitBtn.addEventListener("click", this.onSubmitBtnClicked.bind(this));
        this.devicesDropdown = this.querySelector("[data-devices-dropdown]");
        this.registerCode = this.querySelector("[data-register-code]");

        // set the max date of purchase to today
        this.querySelector("[data-purchase-date]").max = new Date().toISOString().split("T")[0];

        // Get result messages
        this.resultMessage = this.querySelector("[data-result-message]");
        this.resultMessage.success = this.resultMessage.querySelector("[data-success-message]");
        this.resultMessage.error = {};
        this.resultMessage.error.generic = this.resultMessage.querySelector(
          '[data-error-message="generic"]',
        );
        this.resultMessage.error.invalid = this.resultMessage.querySelector(
          '[data-error-message="invalid"]',
        );
        this.resultMessage.error.used = this.resultMessage.querySelector(
          '[data-error-message="used"]',
        );

        // Init Pristine (lib for form validation)
        const config = {
          classTo: "field",
          errorClass: "error",
          successClass: "success",
        };
        this.pristine = new Pristine(this.form, config, true);
        // Date validator
        this.pristine.addValidator(
          this.form.elements["date"],
          (data) => {
            const date = Date.parse(data);
            if (date > Date.now()) {
              this.form.elements["date"].parentNode.classList.add("future-date");
              return false;
            } else {
              this.form.elements["date"].parentNode.classList.remove("future-date");
              return true;
            }
          },
          "Date in future",
        );

        // Get token and device list from server.
        this.getToken()
          .then(async (token) => {
            try {
              this.token = token;
              this.deviceList = await this.getDeviceList(token);
              console.log('this.deviceList==========>', this.deviceList)
              this.createOptions(this.deviceList);

              // Enable submit button.
              this.submitBtn.removeAttribute("disabled");
            } catch (error) {
              console.error("Error occured trying to fetch devices: ", error);
              alert("Couldn't get device list, please try again later.");
            }
          })
          .catch((error) => {
            console.error("Error occured trying to fetch token: ", error);
            alert("Couldn't connect to the server, plase try again later.");
          });
      }

      /**
       * getToken
       * @description Makes a call to the TOKEN_URL to fetch the auth token needed for further api calls.
       * @returns {String} Auth token
       */
      async getToken() {
        const response = await fetch(this.TOKEN_URL);
        const json = await response.json();

        console.log('json==========>', json)
        return json.apptoken;
      }

      /**
       * getDeviceList
       * @description Calls the DEVICE_URL and returns a list of devices from the server.
       * @param {String} token Auth token.
       * @returns {Array} List of devices in the form of { id: Number, name: String }
       */
      async getDeviceList(token) {
        if (!token) {
          return;
        }

        const response = await fetch(this.DEVICE_URL + token);
        const json = await response.json();
        console.log('getDeviceList==========>', json)
        return json;
      }

      /**
       * onSubmitBtnClicked
       * @description Validates the register form, tries to register, and shows the result to the user.
       * @param {Event} e Click event of the submit button.
       */
      async onSubmitBtnClicked(e) {
        e.preventDefault();

        // validate
        const isValid = this.pristine.validate();

        if (isValid) {
          const response = await this.register();
          if (response.success) {
            this.showSuccess();
            this.form.reset();
            this.pristine.reset();
          } else {
            this.showFailure(response.error);
            this.registerCode.value = "";
          }
        }
      }

      /**
       * register
       * @description Tries to register the device with information from the form.
       * @returns {{ success: Bool, error: String}} Returns an object containing the success of the action and a possible error type. error options: ['generic', 'used', 'invalid']
       */
      async register() {
        // grab info
        const name = this.querySelector("[data-register-name]").value;
        const email = this.querySelector("[data-register-email]").value;
        const code = this.querySelector("[data-register-code]").value;
        const device = this.querySelector("[data-devices-dropdown]").value;
        const date = this.querySelector("[data-purchase-date]").value;

        // format data
        const data = JSON.stringify({
          name: name,
          email: email,
          authenticity_code: code,
          device_id: device,
          date_purchase: date,
        });

        const createResponse = (success, error) => {
          return {
            success,
            error,
          };
        };

        // use information to try and register the device.
        try {
          const response = await fetch(this.REGISTER_URL + this.token, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: data,
          });
          const json = await response.json();
          if (json.message) {
            console.error(json.message);
            if (json.message.authenticity_code) {
              if (json.message.authenticity_code.startsWith("Auth")) {
                return createResponse(false, "used");
              } else {
                return createResponse(false, "invalid");
              }
            } else {
              return createResponse(false, "generic");
            }
          } else {
            return createResponse(true, "");
          }
        } catch (error) {
          console.error("Registration error: ", error);
          return createResponse(false, "generic");
        }
      }

      /**
       * createOptions
       * @description Creates an option elements in the devicesDropdown from the given list of devices.
       * @param {Object[]} deviceObjs Array of objects containing the devices to create options for. { id: Number, name: String }
       */
      createOptions(deviceObjs) {
        const elements = [];
        for (const device of deviceObjs) {
          let element = document.createElement("option");
          element.setAttribute("value", device.id);
          let content = document.createTextNode(device.name);
          element.appendChild(content);
          elements.push(element);
        }
        this.devicesDropdown.append(...elements);
      }

      /**
       * showSuccess
       * @description Show the success message to the user.
       */
      showSuccess() {
        this.resultMessage.success.classList.remove("hidden");
        this.resultMessage.error.used.classList.add("hidden");
        this.resultMessage.error.generic.classList.add("hidden");
        this.resultMessage.error.invalid.classList.add("hidden");
      }

      /**
       * showFailure
       * @description Shows an error message to the user of one of the three types ['generic', 'used', 'invalid'].
       * @param {String} type Fail type. one of ['generic', 'used', 'invalid']
       */
      showFailure(type) {
        this.resultMessage.success.classList.add("hidden");
        switch (type) {
          case "invalid":
            this.resultMessage.error.invalid.classList.remove("hidden");
            this.resultMessage.error.generic.classList.add("hidden");
            this.resultMessage.error.used.classList.add("hidden");
            break;

          case "used":
            this.resultMessage.error.used.classList.remove("hidden");
            this.resultMessage.error.generic.classList.add("hidden");
            this.resultMessage.error.invalid.classList.add("hidden");
            break;

          case "generic":
          default:
            this.resultMessage.error.generic.classList.remove("hidden");
            this.resultMessage.error.invalid.classList.add("hidden");
            this.resultMessage.error.used.classList.add("hidden");
            break;
        }
      }
    }

    customElements.define("register-device", RegisterDevice);
  }
})();
